import '../../App.css';
import '../../Css/Description.css';
import { Link } from 'react-router-dom';

export default function ServicesDescription(props) {

  const isReversed = props.orientation %2 === 0;
  return (
    <div id={props.id} className='section-separator service-background section-border-top'>
        <div className='title'>
          <div className='section-title'>{props.title}</div> 
          <div className='HLContainer'><div className='big-line'></div></div>
        </div>
        <div className={isReversed ? 'description reversed' : 'description'}>
          <div>
            <img className='hexagon' src={props.image}></img>
          </div>
          <div className={isReversed ? 'text service-text-container ' : 'text reversed service-text-container'}>{props.description}</div>
        </div>
    </div>
    
  );
}